import type { IFinanceGridPriceEntry } from "./types";
import { formatGridPrice } from "./utils";

/** Prix par pays inline : drapeau + nom du pays + montant, ou « — » si aucun. */
export const CountryPricesCell = ({
    childCurrencies,
}: {
    childCurrencies: IFinanceGridPriceEntry["childCurrencies"];
}) => {
    if (childCurrencies.length === 0) {
        return <span className="text-xs text-foreground">—</span>;
    }

    return (
        <span className="flex flex-wrap gap-x-3 gap-y-0.5 text-xs tabular-nums text-foreground">
            {childCurrencies.map((c) => (
                <span key={`${c.country}-${c.currency}`} className="whitespace-nowrap">
                    {c.flag} {c.countryName}{" "}
                    <span className="font-semibold text-grey-900">{formatGridPrice(c.price, c.currency)}</span>
                </span>
            ))}
        </span>
    );
};
